import styled, { keyframes } from "styled-components";

const shimmer = keyframes`
  from { background-position: 200% 0; }
  to   { background-position: -200% 0; }
`;

interface SkeletonProps {
  width?: string;
  height?: string;
}

export const Skeleton = styled.span<SkeletonProps>`
  display: inline-block;
  width: ${(props) => props.width ?? "100%"};
  height: ${(props) => props.height ?? "1rem"};
  border-radius: 0.375rem;
  background: linear-gradient(
    90deg,
    var(--surface-3) 25%,
    var(--surface-2) 50%,
    var(--surface-3) 75%
  );
  background-size: 200% 100%;
  animation: ${shimmer} 1.4s ease-in-out infinite;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

// Avatar circular com as iniciais do profissional.
export const Avatar = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.25rem;
  height: 2.25rem;
  border-radius: 50%;
  background: rgba(var(--primary-rgb), 0.12);
  color: var(--primary);
  font-weight: 700;
  font-size: 0.8rem;
  line-height: 1;
  flex-shrink: 0;
`;

// Linha de profissional clicável (abre/fecha o detalhamento do split).
export const ClickableRow = styled.tr`
  cursor: pointer;
  transition: background-color 0.15s ease;
`;

